// If you add env vars => Add it to initEnvVars function in server/api/app/app.controller.js

const envVars = process.env.NODE_ENV === 'development' || process.env.BASE_URL
    ? process.env
    : ((typeof window !== 'undefined' && window.env_vars) || process.env || {});
const url = envVars.BASE_URL || 'http://localhost:8000/';
const config = {
    version: envVars.APP_VERSION || '',
	url,
    api: envVars.API_URL || `${url}api`, // 'https://dev.directos.eu',
    ws: envVars.WEBSOCKET_URL || '',
    port: envVars.PORT || 8000,
    application: {
        name: 'Directos.eu',
        email: 'contact@directos.eu',
        phone: '+33.6.68.07.32.22',
        seo: {
            defaultTitle: '',
        },
        options: {
        },
        discount: {
        },
        rating: {
            max: 5,
        },
        order: {
            minimum: 20,
        },
        payment: {
            transfer: {
                bankName: 'Société Générale',
                iban: 'FR76 3000 3032 8700 0200 5741 282',
                bic: 'SOGEFRPP',
            },
        },
		fidelity: {
			pointsPerEuro: 1, // 1 point = 1 euro
			pointsPerInvitation: 50, // 50 points = invitation with successful order
			invitationValidityDays: 7,
		},
        security: {
            secureApiCall: false,
            secureApiCallHeader: 'Custom-Soc', // SOC: Secure Origin Checker
        },
		enableINP: false,
    },
    aws: {
        s3: {
            region: 'eu-west-3',
            bucket: envVars.S3_BUCKET || 'dev.directos.eu',
        },
    },
    facebook: {
		pixelId: process.env.FACEBOOK_PIXEL_ID || '',
    },
    google: {
        analytics: {
            trackingCode: envVars.GOOGLE_ANALYTICS_TRACKING_CODE || '',
            trackingCodeGA4: envVars.GOOGLE_ANALYTICS_TRACKING_CODE_GA4 || '',
        },
		merchant: {
			id: process.env.GOOGLE_MERCHANT_ID || '125274049',
		},
		gtag: {
			id: 'AW-794633346',
		},
    },
    stripe: {
        publicKey: envVars.STRIPE_PUBLIC_KEY || 'pk_test_DppRmk7CNbN3Rvfd6ZnLn1UD',
        acceptedMethods: ['Visa', 'MasterCard', 'American Express'],
    },
    paypal: {
        clientId: envVars.PAYPAL_CLIENT_ID || 'AdcrDtBqOcjWWbXDpaB-rVjmrqT-F-6y7LDVx6cboHjrWEnPufVs-KKJavmkKiifJy_V7-60v1wfpIhm',
    },
    mondialrelay: {
        clientId: 'CC210E6G',
    },
    bugsnag: {
        key: envVars.BUGSNAG_KEY || '',
    },
    selldorado: {
        id: '660024808',
    },
	hcaptcha: {
		siteKey: envVars.HCAPTCHA_SITE_KEY || '',
	},
};
// console.log(config);
// process.env.NODE_ENV === 'development' && console.log('Client config', config);
// export default config;
module.exports = config;
